import { render, staticRenderFns } from "./webPng.vue?vue&type=template&id=29536b0d&scoped=true&"
import script from "./webPng.vue?vue&type=script&lang=js&"
export * from "./webPng.vue?vue&type=script&lang=js&"
import style0 from "./webPng.vue?vue&type=style&index=0&id=29536b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29536b0d",
  null
  
)

export default component.exports